import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './assets/css/App.css';

import App from './App';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Provider } from "react-redux";

import store from "app/store";
import { TimezoneProvider } from "contexts/TimezoneContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Provider store={store}>
        <TimezoneProvider>
          <App />
          <ToastContainer />
        </TimezoneProvider>
      </Provider>
    </React.StrictMode>
  </BrowserRouter>,
);
